export interface NavLink {
  label: string;
  href: string;
}

export interface AppItem {
  id: number;
  rank: number;
  name: string;
  tag: string;
  rating: number;
  downloads: string;
  desc: string;
  tags: string[];
  image: string;
  isHot?: boolean;
}

export interface Category {
  id: string;
  name: string;
  en: string;
  desc: string;
  count: string;
  icon: string;
  image: string;
}

export interface Article {
  id: number;
  title: string;
  excerpt: string;
  category: string;
  date: string;
  readTime: string;
  tag: string;
  image: string;
}

export interface FaqItem {
  q: string;
  a: string;
}

export const navLinks: NavLink[] = [
  { label: "首页", href: "#home" },
  { label: "平台榜单", href: "#ranking" },
  { label: "漫画分类", href: "#category" },
  { label: "阅读攻略", href: "#guide" },
  { label: "常见问题", href: "#faq" },
  { label: "关于我们", href: "#about" },
];

export const heroStats = [
  { value: "26", unit: "个", label: "收录平台" },
  { value: "120+", unit: "", label: "篇攻略" },
  { value: "5", unit: "类", label: "漫画分类" },
  { value: "98%", unit: "", label: "读者满意度" },
];

export const apps: AppItem[] = [
  {
    id: 1,
    rank: 1,
    name: "哔哩哔哩漫画",
    tag: "二次元追更首选",
    rating: 9.6,
    downloads: "超 5000 万下载",
    desc: "国漫与日漫资源均衡，正版授权、更新同步快，支持弹幕式讨论区与章节评论区，追更氛围浓郁。",
    tags: ["正版授权", "更新快", "高清"],
    image: "https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20smartphone%20displaying%20colorful%20manga%20covers%2C%20warm%20orange%20background%2C%20minimal%20composition%2C%20glowing%20screen%2C%20youthful%20tech%20aesthetic&width=800&height=800&seq=comic-app-bili&orientation=squarish",
    isHot: true,
  },
  {
    id: 2,
    rank: 2,
    name: "腾讯动漫",
    tag: "国漫独家大厂",
    rating: 9.4,
    downloads: "超 8000 万下载",
    desc: "头部国漫IP集中地，多部现象级作品独家连载，画质与稳定性出色，适合偏爱武侠玄幻题材的读者。",
    tags: ["国漫丰富", "独家IP", "稳定"],
    image: "https://readdy.ai/api/search-image?query=Cinematic%20anime%20scene%20of%20ancient%20Chinese%20heroes%20with%20dragon%20and%20phoenix%2C%20warm%20gold%20and%20orange%20lighting%2C%20epic%20wuxia%20fantasy%20art%2C%20polished%20game%20artwork%20style&width=800&height=800&seq=comic-app-tencent&orientation=squarish",
  },
  {
    id: 3,
    rank: 3,
    name: "快看漫画",
    tag: "条漫社区爆款",
    rating: 9.2,
    downloads: "超 2 亿下载",
    desc: "以竖屏条漫起家的社区型平台，原创作品活跃、题材多元，恋爱、日常、搞笑类内容更新密集，社交玩法丰富。",
    tags: ["原创条漫", "社区互动", "题材多元"],
    image: "https://readdy.ai/api/search-image?query=Colorful%20webtoon%20strip%20collage%20on%20a%20phone%20screen%2C%20pastel%20and%20vibrant%20flat%20colors%2C%20playful%20comic%20characters%2C%20modern%20casual%20style%2C%20warm%20cream%20background&width=800&height=800&seq=comic-app-kuaikan&orientation=squarish",
  },
  {
    id: 4,
    rank: 4,
    name: "咚漫",
    tag: "韩漫人气担当",
    rating: 9.0,
    downloads: "超 3000 万下载",
    desc: "韩国漫画与条漫的优质入口，画风精致、叙事利落，恋爱与奇幻题材突出，适合喜欢一口气追完的读者。",
    tags: ["韩漫", "画风精致", "恋爱奇幻"],
    image: "https://readdy.ai/api/search-image?query=Korean%20romance%20webtoon%20style%20illustration%2C%20elegant%20couple%20under%20blossom%20trees%2C%20soft%20pastel%20pink%20and%20teal%20tones%2C%20clean%20flat%20art%2C%20romantic%20atmosphere&width=800&height=800&seq=comic-app-dongman&orientation=squarish",
  },
  {
    id: 5,
    rank: 5,
    name: "哔哩哔哩",
    tag: "番剧漫画联动",
    rating: 9.3,
    downloads: "超 3 亿下载",
    desc: "视频平台衍生漫画入口，动画番剧与漫画联动紧密，适合先看动画再补漫画的用户，社区氛围浓厚。",
    tags: ["番剧联动", "社区", "弹幕文化"],
    image: "https://readdy.ai/api/search-image?query=Friendly%20anime%20mascot%20girl%20with%20headphones%20watching%20cartoons%2C%20warm%20orange%20and%20pink%20tones%2C%20clean%20modern%20illustration%2C%20youthful%20and%20cheerful&width=800&height=800&seq=comic-app-bilibili&orientation=squarish",
  },
  {
    id: 6,
    rank: 6,
    name: "Piccoma",
    tag: "日漫精品专区",
    rating: 8.8,
    downloads: "海外人气",
    desc: "主打日本漫画的精品平台，漫画类型齐全、更新规范，适合追逐日漫经典与连载新作的资深读者。",
    tags: ["日漫", "精品内容", "连载规范"],
    image: "https://readdy.ai/api/search-image?query=Japanese%20manga%20reader%20character%20holding%20a%20book%20in%20a%20cozy%20room%2C%20soft%20warm%20lighting%2C%20gentle%20anime%20style%2C%20peaceful%20reading%20atmosphere&width=800&height=800&seq=comic-app-piccoma&orientation=squarish",
  },
];

export const categories: Category[] = [
  {
    id: "guoman",
    name: "国漫",
    en: "GuoMan",
    desc: "武侠仙侠、玄幻古风，本土IP的东方美学与热血成长。",
    count: "1200+ 部在更",
    icon: "ri-empathize-line",
    image: "https://readdy.ai/api/search-image?query=Traditional%20Chinese%20wuxia%20xianxia%20anime%20illustration%2C%20elegant%20swordsman%20in%20flowing%20robes%20standing%20on%20misty%20mountains%2C%20ink%20wash%20painting%20style%20with%20warm%20amber%20and%20teal%20accents%2C%20atmospheric%20and%20refined%2C%20vertical%20composition&width=800&height=800&seq=comic-cat-guoman&orientation=squarish",
  },
  {
    id: "riman",
    name: "日漫",
    en: "RiMan",
    desc: "热血番剧、经典神作与连载新番，王道与日常齐飞。",
    count: "900+ 部在更",
    icon: "ri-fire-line",
    image: "https://readdy.ai/api/search-image?query=Modern%20anime%20style%20illustration%20of%20a%20teenage%20reader%20surrounded%20by%20floating%20manga%20volumes%2C%20warm%20sunset%20orange%20tones%2C%20clean%20line%20art%2C%20energetic%20youthful%20vibe%2C%20soft%20gradient%20background&width=800&height=800&seq=comic-cat-riman&orientation=squarish",
  },
  {
    id: "hanman",
    name: "韩漫",
    en: "HanMan",
    desc: "竖屏条漫新体验，恋爱、奇幻与悬疑的利落叙事。",
    count: "600+ 部在更",
    icon: "ri-heart-3-line",
    image: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20vertical%20style%20illustration%2C%20stylish%20young%20woman%20with%20vibrant%20colors%2C%20clean%20flat%20pastel%20art%2C%20dynamic%20composition%2C%20contemporary%20K-webtoon%20aesthetic&width=800&height=800&seq=comic-cat-hanman&orientation=squarish",
  },
  {
    id: "meiman",
    name: "美漫",
    en: "MeiMan",
    desc: "超级英雄与美式漫画，鲜明张力与硬朗线条。",
    count: "300+ 部在更",
    icon: "ri-flashlight-line",
    image: "https://readdy.ai/api/search-image?query=American%20superhero%20comic%20book%20style%20illustration%2C%20bold%20colorful%20action%20pose%2C%20halftone%20dots%20and%20burst%20background%2C%20vibrant%20orange%20and%20teal%2C%20classic%20comic%20panel%20energy&width=800&height=800&seq=comic-cat-meiman&orientation=squarish",
  },
];

export const articles: Article[] = [
  {
    id: 1,
    title: "新手入门：如何挑选适合自己的漫画阅读软件",
    excerpt: "第一次接触漫画阅读，面对众多平台容易眼花缭乱。本文从画质、更新速度、资源广度与使用体验四个维度，帮你快速锁定最合适的那一款。",
    category: "入门指南",
    date: "2026-08-12",
    readTime: "6 分钟",
    tag: "新手",
    image: "https://readdy.ai/api/search-image?query=Cozy%20reading%20scene%20of%20a%20person%20on%20a%20couch%20reading%20comics%20on%20a%20phone%2C%20warm%20orange%20morning%20light%2C%20minimal%20lifestyle%20illustration&width=1200&height=800&seq=comic-art-01&orientation=landscape",
  },
  {
    id: 2,
    title: "热门国漫盘点：这几部高分作品值得一追",
    excerpt: "从玄幻热血到江湖古风，盘点头部国漫平台上的高分在更作品，包含剧情亮点、画风特色与适合人群，帮你快速找到下一部入坑之作。",
    category: "国漫推荐",
    date: "2026-08-08",
    readTime: "8 分钟",
    tag: "国漫",
    image: "https://readdy.ai/api/search-image?query=Two%20wuxia%20heroes%20facing%20off%20in%20a%20bamboo%20forest%2C%20dramatic%20warm%20golden%20lighting%2C%20anime%20battle%20scene%2C%20epic%20atmosphere&width=1200&height=800&seq=comic-art-02&orientation=landscape",
  },
  {
    id: 3,
    title: "日漫入坑指南：从经典神作到连载新番",
    excerpt: "日漫体系庞大，题材丰富。从耳熟能详的经典长篇到每周更新的新番连载，整理出一份由浅入深的入坑路线与阅读平台选择建议。",
    category: "日漫推荐",
    date: "2026-08-03",
    readTime: "7 分钟",
    tag: "日漫",
    image: "https://readdy.ai/api/search-image?query=Cheerful%20group%20of%20anime%20characters%20celebrating%20together%2C%20warm%20sunset%20tones%2C%20bright%20clean%20illustration%2C%20new%20series%20montage&width=1200&height=800&seq=comic-art-03&orientation=landscape",
  },
  {
    id: 4,
    title: "韩漫条漫魅力：竖屏阅读的新体验",
    excerpt: "竖屏条漫改变了传统阅读方式，以适配手机、节奏明快著称。带你看懂韩漫平台的内容结构与独有玩法，感受短小精悍的追更乐趣。",
    category: "韩漫推荐",
    date: "2026-07-28",
    readTime: "5 分钟",
    tag: "韩漫",
    image: "https://readdy.ai/api/search-image?query=Webtoon%20reading%20app%20interface%20illustration%20with%20vertical%20comic%20strips%2C%20pastel%20colors%2C%20phone%20on%20a%20desk%2C%20clean%20modern%20design&width=1200&height=800&seq=comic-art-04&orientation=landscape",
  },
  {
    id: 5,
    title: "阅读体验提升：缓存下载与护眼模式小技巧",
    excerpt: "通勤路上想离线阅读？长时间刷漫画担心伤眼？整理几个常见的设置技巧，让缓存、护眼、翻页等细节体验全面升级。",
    category: "使用技巧",
    date: "2026-07-20",
    readTime: "4 分钟",
    tag: "技巧",
    image: "https://readdy.ai/api/search-image?query=Phone%20with%20night%20reading%20mode%20dark%20warm%20theme%20on%20a%20bedside%20table%2C%20cozy%20dorm%20lamp%20glow%2C%20comfortable%20evening%20reading%20scene&width=1200&height=800&seq=comic-art-05&orientation=landscape",
  },
  {
    id: 6,
    title: "漫画版权小课堂：支持正版才能长久追更",
    excerpt: "正版平台的稳定更新与高清画质离不开创作者与平台的共同努力。聊聊为什么支持正版、如何识别可靠平台，做理性而长久的读者。",
    category: "行业观察",
    date: "2026-07-14",
    readTime: "6 分钟",
    tag: "版权",
    image: "https://readdy.ai/api/search-image?query=Open%20book%20with%20light%20and%20shield%20concept%20illustration%2C%20supporting%20original%20creators%2C%20warm%20golden%20tones%2C%20minimal%20symbolic%20design&width=1200&height=800&seq=comic-art-06&orientation=landscape",
  },
];

export const faqs: FaqItem[] = [
  {
    q: "在哪里可以免费阅读正版漫画？",
    a: "目前主流正版漫画平台都会提供免费试读章节与限免作品，你可以先通过各平台的免费专区、每日签到、活动福利等方式体验内容质量，再决定是否开通会员。正版平台更稳定、更新更及时，也更能保障创作者收益。",
  },
  {
    q: "免费阅读和付费会员有什么区别？",
    a: "免费阅读通常可以试读作品前几话，付费会员则可解锁全部章节、抢先阅读最新一话，并享受去广告、高清画质、离线下载等增值服务。不同平台规则略有差异，建议根据自己追更频率选择。",
  },
  {
    q: "哪些平台支持离线下载阅读？",
    a: "绝大多数主流漫画平台都支持将已更新的章节缓存到本地，方便在地铁、飞机等无网络环境下阅读。你可以在平台设置或单部作品页面找到『下载』或『缓存』入口，按需下载即可。",
  },
  {
    q: "如何获得更好的追更体验？",
    a: "建议开启平台的更新提醒与订阅功能，关注心仪作品的更新公告；同时根据阅读场景开启护眼模式与夜间主题，配合缓存下载，让碎片时间也能顺畅追更，不错过每一话。",
  },
  {
    q: "手机和电脑上都能看漫画吗？",
    a: "可以。主流平台均提供移动端 App 与网页版，部分还支持平板适配与多端登录，进度会同步到账号。在电脑上大屏阅读细节更清晰，手机上则更方便随时随地追更。",
  },
  {
    q: "未成年人可以观看所有漫画吗？",
    a: "各平台都设有年龄分级与内容审核机制，部分含成人与暴力题材的作品会设置观看门槛或需家长验证。建议读者结合自身年龄选择适合的内容，家长也可开启青少年模式进行管理。",
  },
];

export const guideSteps = [
  {
    icon: "ri-search-eye-line",
    title: "明确需求",
    desc: "先想清楚主要看国漫、日漫还是韩漫，是追热门连载还是补经典老番。",
  },
  {
    icon: "ri-git-branch-line",
    title: "对比平台",
    desc: "从画质、更新速度、资源广度、付费方式和使用体验几个维度横向比较。",
  },
  {
    icon: "ri-article-line",
    title: "小成本试读",
    desc: "先利用免费章节和限免作品体验，确认画风、翻译与阅读手感是否合拍。",
  },
  {
    icon: "ri-heart-add-line",
    title: "长期追更",
    desc: "锁定 1–2 个主力平台开启订阅与提醒，把喜欢的作品沉淀成自己的追更清单。",
  },
];

export const aboutValues = [
  {
    icon: "ri-shield-check-line",
    title: "坚持正版",
    desc: "只推荐拥有正式授权、内容规范的正版平台，做理性而长久的读者。",
  },
  {
    icon: "ri-focus-3-line",
    title: "客观中立",
    desc: "以实际使用与读者反馈为依据，不掺水、不软广，给出可落地的建议。",
  },
  {
    icon: "ri-flag-2-line",
    title: "更新及时",
    desc: "持续跟进平台变动与热门新作，让攻略与榜单始终贴近你的真实需求。",
  },
];